/* Sprout&Joy: show a minimal cart shortcut only after native buy buttons scroll away. */
(() => {
  const bar = document.querySelector('[data-sj-sticky-buy]');
  if (!bar) return;
  const sectionId = bar.dataset.productSection;
  const info = document.getElementById('MainProduct-' + sectionId);
  const trigger = bar.querySelector('[data-sj-sticky-buy-trigger]');
  const label = bar.querySelector('[data-sj-sticky-buy-label]');
  if (!info || !trigger || !label) return;

  let frame = null;

  function isOnScreen(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
  }

  function update() {
    const main = document.getElementById('ProductSubmitButton-' + sectionId);
    const secondary = document.getElementById('SecondaryProductSubmitButton-' + sectionId);
    if (!main || !main.closest('product-form')) {
      bar.hidden = true;
      return;
    }

    const text = main.querySelector('span')?.textContent?.trim();
    if (text) label.textContent = text;

    const disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
    trigger.disabled = disabled;

    /* Only appears when the shopper has scrolled beyond the native purchase area. */
    const rect = main.getBoundingClientRect();
    const passedMain = rect.bottom < 0;
    const dialogOpen = !!document.querySelector('#cart-notification.active, cart-drawer.active, quick-add-modal[open]');
    const shippingShowing = !!document.querySelector('.sj-top-shipping-section.sj-shipping-pinned');
    const nearFooter = !!document.querySelector('footer') &&
      document.querySelector('footer').getBoundingClientRect().top < window.innerHeight - 24;
    const shouldShow = passedMain && !isOnScreen(secondary) && !dialogOpen &&
      !shippingShowing && !nearFooter;

    bar.hidden = !shouldShow;
  }

  function schedule() {
    if (frame !== null) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      update();
    });
  }

  trigger.addEventListener('click', () => {
    const main = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!main || main.disabled || main.getAttribute('aria-disabled') === 'true') return;
    /* Click the actual native Dawn submit so variant, quantity, apps and pixels behave as before. */
    bar.hidden = true;
    main.click();
  });

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('change', schedule);
  info.addEventListener('input', schedule);

  /* Dawn can replace the button when a variant changes; reflect its current state. */
  new MutationObserver(schedule).observe(info, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled']
  });

  const cartNotification = document.getElementById('cart-notification');
  if (cartNotification) {
    new MutationObserver(schedule).observe(cartNotification, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  const shipping = document.querySelector('.sj-top-shipping-section');
  if (shipping) {
    new MutationObserver(schedule).observe(shipping, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /* Refresh when the customer closes the cart confirmation. */
  document.addEventListener('click', (e) => {
    if (e.target.closest('cart-notification')) requestAnimationFrame(schedule);
  });

  schedule();
})();
